import React from 'react'
import { withRouter } from 'react-router-dom'
import BGParticle from '../../utils/BGParticle'
import './style.css'
import { inject, observer } from 'mobx-react'
import 'animate.css'
import LoginForm from './LoginForm'

class Login extends React.Component {
  componentDidMount () {
    this.initParticle()
  }

  componentWillUnmount () {
    this.particle && this.particle.destory()
  }

  initParticle = () => {
    if (document.getElementById('backgroundBox')) {
      this.particle = new BGParticle('backgroundBox')
      this.particle.init()
    }
  }

  render () {
    return (
      <div id='login-page'>
        <div>
          <div id='backgroundBox' style={styles.backgroundBox}/>
          <div className='container'>
            <LoginForm
              className='box showBox'
              appStore={this.props.appStore}
              history={this.props.history}
              location={this.props.location}/>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  backgroundBox: {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    background: 'linear-gradient(135deg, #0f172a 0%, #155e75 52%, #0f766e 100%)',
    backgroundSize: 'cover',
    transition:'all .5s'
  },
  focus: {
    // transform: 'scale(0.7)',
    width: '20px',
    opacity: 1
  },
  loadingBox:{
    position:'fixed',
    top:'50%',
    left:'50%',
    transform:'translate(-50%,-50%)'
  },
  loadingTitle:{
    position:'fixed',
    top:'50%',
    left:'50%',
    marginLeft: -45,
    marginTop: -18,
    color:'#000',
    fontWeight:500,
    fontSize:24
  },
}

export default withRouter(inject('appStore')(observer(Login)))



// WEBPACK FOOTER //
// ./src/routes/Login/index.js